import { ComponentProps } from 'react';
import { VisuallyHidden as VisuallyHiddenPrimitive } from '@radix-ui/react-visually-hidden';

export const VisuallyHidden = (
  props: ComponentProps<typeof VisuallyHiddenPrimitive>,
) => {
  return <VisuallyHiddenPrimitive {...props} />;
};
